import { render, staticRenderFns } from "./SkeletonScreen.vue?vue&type=template&id=047e5286&scoped=true&"
import script from "./SkeletonScreen.vue?vue&type=script&lang=js&"
export * from "./SkeletonScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e5286",
  null
  
)

export default component.exports